import { render, staticRenderFns } from "./DisabilitiesRateDetail.vue?vue&type=template&id=68b0f55a&"
import script from "./DisabilitiesRateDetail.vue?vue&type=script&lang=js&"
export * from "./DisabilitiesRateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports